// Import all guide markdown files
import quickStartMd from "../../quick-start-guide/quick-start.md?raw";
import submitThreatModelMd from "../../quick-start-guide/submit-threat-model.md?raw";
import interactWithResultsMd from "../../quick-start-guide/interact-with-threat-model-results.md?raw";
import exportThreatModelsMd from "../../quick-start-guide/export-threat-models.md?raw";
import tuiKnowledgeSourcesMd from "../../quick-start-guide/tui-knowledge-sources.md?raw";
import replayThreatModelMd from "../../quick-start-guide/replay-threat-model.md?raw";
import usingSentryMd from "../../quick-start-guide/using-sentry.md?raw";
import usingAttackTreesMd from "../../quick-start-guide/using-attack-trees.md?raw";
import collaborateMd from "../../quick-start-guide/collaborate-on-threat-models.md?raw";
import smeComparisonMd from "../../quick-start-guide/sme-comparison.md?raw";
import troubleshootingMd from "../../quick-start-guide/troubleshooting-common-issues.md?raw";

// Guide metadata and content mapping
// Order reflects user journey: Getting Started → Core Features → Advanced Features → Optional Features → Help
export const guides = {
  "quick-start": {
    title: "Quick Start",
    content: quickStartMd,
  },
  "submit-threat-model": {
    title: "Submit Threat Model",
    content: submitThreatModelMd,
  },
  "interact-with-threat-model-results": {
    title: "Interact with Results",
    content: interactWithResultsMd,
  },
  "export-threat-models": {
    title: "Export Threat Models",
    content: exportThreatModelsMd,
  },
  "tui-knowledge-sources": {
    title: "TUI Knowledge Sources",
    content: tuiKnowledgeSourcesMd,
  },
  "replay-threat-model": {
    title: "Replay Threat Model",
    content: replayThreatModelMd,
  },
  "using-sentry": {
    title: "Using Sentry",
    content: usingSentryMd,
  },
  "using-attack-trees": {
    title: "Using Attack Trees",
    content: usingAttackTreesMd,
  },
  "collaborate-on-threat-models": {
    title: "Collaborate on Threat Models",
    content: collaborateMd,
  },
  "sme-comparison": {
    title: "SME Comparison",
    content: smeComparisonMd,
  },
  "troubleshooting-common-issues": {
    title: "Troubleshooting",
    content: troubleshootingMd,
  },
};

// Helper to get guide by slug
export const getGuide = (slug) => {
  return guides[slug] || null;
};

// Get all guide slugs
export const getGuideSlugs = () => {
  return Object.keys(guides);
};
